import React from 'react'

const DotnetMainContent = () => {
  return (
    <>
      <section className="services-details-area ptb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 services-details">
              <div className="ml-about-content">
                {/* <h2>.Net Technology Development Company</h2> */}
                <h1>Pioneer in Dot Net Technology Development</h1>
                <div className="bar" />
              </div>
            </div>
            <div className="col-lg-6 services-details">
              <div className="services-details-desc">
                <p className="mb-3">
                  Alobha Technologies is capable in developing desktop and online applications with Dot Net Technology Development. .NET enables
                  us to create revolutionary, powerful, cost-effective, business
                  solutions that help our customers get more from existing technology
                  investments. It helps us go ahead of advancements and create
                  adaptable and versatile solutions.
                </p>
                <p>
                  Our technology team develops software that is competent and prolific
                  enough to meet the specific requirement of the client while also
                  incorporating our long-term experience.
                </p>
                {/* <h3>
                  <b>Why .Net Technologies?</b>
                </h3> */}
                <h2 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: "Montserrat" }}>
                  <b>Why .Net Technologies?</b>
                </h2>
                <p>
                  .NET is a preferred technology today due to its interoperability and
                  flexibility. .NET technologies enable software engineers to rapidly
                  develop, and manage, and utilize associated and secured solutions.
                  Also, the Microsoft .NET Development services are equipped with a
                  number of powerful tools which are really helpful for achieving and
                  resolving complex, challenging and vital tasks in a very effective
                  manner.
                </p>
              </div>
            </div>
            <div className="col-lg-6 services-details-image">
              <img loading="lazy"
                src="assets/img/service-detail-image/111.webp"
                className="wow fadeInUp"
                alt=""
              />
            </div>
          </div>
          <div className="separate" />
          <div className="row align-items-center">
            <div className="col-lg-6 services-details-image">
              <img loading="lazy"
                src="assets/img/service-detail-image/dotnet2.webp"
                className="wow fadeInUp"
                alt=""
              />
            </div>
            <div className="col-lg-6 services-details">
              <div className="services-details-desc">
                <div className="ml-about-content">
                  <h2>What Alobha offers</h2>
                  <div className="bar" />
                  <p>
                    Alobha offers its services on desktop application, mobile
                    application and web based application. At Alobha we try to provide
                    the custom solution to our clients which covers various
                    industrial/business domains like ecommerce sector, Schools &amp;
                    Institutions, Finance and accounting Solutions, Business Website
                    and other solutions.
                  </p>
                  <h3>
                    <b>The Key Categories of our Offered Services are:</b>
                  </h3>
                  <div className="services-details-accordion">
                    <ul className="accordion">
                      <li className="accordion-item">
                        {" "}
                        <a
                          className="accordion-title pl-4"
                          href="javascript:void(0);"
                        >
                          ASP .Net Web Application Development
                        </a>
                      </li>
                      <li className="accordion-item">
                        {" "}
                        <a
                          className="accordion-title pl-4"
                          href="javascript:void(0);"
                        >
                          Business/ Enterprise Solutions Development &amp; Integration
                        </a>
                      </li>
                      <li className="accordion-item">
                        {" "}
                        <a
                          className="accordion-title pl-4"
                          href="javascript:void(0);"
                        >
                          .NET based Product’s Customisation;
                        </a>
                      </li>
                      <li className="accordion-item">
                        {" "}
                        <a
                          className="accordion-title pl-4"
                          href="javascript:void(0);"
                        >
                          .NET Product’s Maintenance &amp; Support Services
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default DotnetMainContent